import BetaBadge from "./BetaBadge.en";
import LiteScroller from "./LiteScroller.en";
import ShowMore from "./ShowMore.en";
import { default as opre } from "./opre/lang.en"; // so translationMixin works, but I can keep the components in their own directory.

export default {
	BetaBadge,
	LiteScroller,
	ShowMore,
	...opre
};
